import React from "react";
import UiMainWrapper from "../../../components/common/UiMainWrapper";
import TopHeader from "../../../components/header/TopHeader";
import quizBanner from "../../../../../styles/img/quiz-banner.png";
import { UiBannerBottomBar } from "../../../components/common/UiBannerBottomBar";
import KnowledgeInnerBaner from "../Views/KnowledgeInnerBanner";
import { UiContentCol, UiContentWr } from "../../../components/common/UiPageElements";
import { UiCol, UiRowContainer, UiSingleRow } from "../../../components/grid-container/GridContainer";
import { QuizzerCard } from "../Views/QuizzerCard";
import Footer from "../../../components/footer/Footer";
import { UiBlueBox } from "../../../../_uiComponents/common/UiBlueBox";
import TropyStar from '../../../../../styles/img/tropystar.png';
import { UiGrayBox } from "../../../../_uiComponents/common/UiGrayBox";
import { Button } from "react-bootstrap";
import UiHowCampaignsWork from "../../../components/common/UiHowCampaignsWork";
import { QuestionLinks } from "../../../../_uiComponents/common/QuestionLinks";
import { CircleTickGreenFill } from "../../../../../styles/img/svg/CircleGreenFill";


export const CourseQuizLandingPage = () => {
    return (
        <>
            <UiMainWrapper>
                <TopHeader />

                <KnowledgeInnerBaner
                    title="Volvo 4x4 Programme"
                    description="Let’s sharpen up your knowledge with fast informative quiz!"
                    sliderCardImage={quizBanner}
                    className="sb-knowldg-inner-banner" />

                <UiBannerBottomBar
                    prevPage="Knowledge"
                    prevPageLink="/ui"
                    currentPage="   Volvo 4x4 Quiz"
                    currentPageLink="/ui/incentives-pre-register" />

                <UiContentWr>
                    <UiRowContainer fluid="fluid" className="sb-quiz-main-page">
                        <UiContentCol>
                            <UiSingleRow>
                                <UiCol lg="3" className="sb-quiz-main-page__links">
                                    <QuestionLinks>
                                        <li className="active"><a href="#"><CircleTickGreenFill/>  About This Quiz</a></li>
                                        <li><a href="#">Contents</a></li>
                                        <li><a href="#">Need to know</a></li>
                                    </QuestionLinks>
                                    <UiBlueBox >
                                        <img src={TropyStar} />
                                        <h3>Badge Available</h3>
                                    </UiBlueBox>
                                </UiCol>
                                <UiCol lg="9" className="sb-quiz-main-page__content">
                                    <h3>About This Quiz</h3>
                                    <h4>Title</h4>

                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua.</p>

                                    <p> Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua.</p>

                                    <p>  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua.</p>

                                    <p> Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua.</p>

                                    <UiGrayBox>
                                        <UiSingleRow>
                                            <UiCol lg="3" className="sb-quiz-main-page-bb">
                                                <UiBlueBox >
                                                    <img src={TropyStar} />
                                                    <h3>Badge Available</h3>
                                                </UiBlueBox>
                                            </UiCol>
                                            <UiCol lg="9">
                                                <h2>Enrol Now</h2>
                                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                                                    tempor incididunt ut ero labore et dolore magna aliqua. </p>
                                                <Button className="sb-geen-btn">Start Quiz?</Button>
                                            </UiCol>
                                        </UiSingleRow>

                                    </UiGrayBox>

                                    <h3>Quiz Details</h3>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua.  </p>

                                    <UiSingleRow className="sb-quiz-details-cards">
                                        <UiCol lg="2">
                                            <div className="sb-quiz-details-cards__card">
                                                <h4>Questions:</h4>
                                                <h3>10</h3>
                                            </div>
                                        </UiCol>

                                        <UiCol lg="3">
                                            <div className="sb-quiz-details-cards__card">
                                                <h4>Time to Complete:</h4>
                                                <h3>45 mins</h3>
                                            </div>
                                        </UiCol>

                                        <UiCol lg="2">
                                            <div className="sb-quiz-details-cards__card">
                                                <h4>Attempts:</h4>
                                                <h3>1/3</h3>
                                            </div>
                                        </UiCol>

                                    </UiSingleRow>


                                    <Button disabled>Back ?</Button>
                                    <Button className="sb-geen-btn">Start Quiz?</Button>

                                </UiCol>
                            </UiSingleRow>
                        </UiContentCol>
                    </UiRowContainer>
                </UiContentWr>

                <UiContentWr>
                    <UiRowContainer fluid="fluid">
                        <UiCol lg="12">
                            <UiContentCol>
                                <UiHowCampaignsWork title="How Quizes Work" />
                            </UiContentCol>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>

                <Footer />

            </UiMainWrapper>


        </>
    )
}